/**
 * Link to a crew member's admin profile page (/admin/crew/:id).
 *
 * ADMIN-ONLY: only render this from admin-facing screens — the target route
 * lives behind the /admin branch, and crew must not be steered there.
 */

import { Link } from 'react-router-dom';

interface CrewProfileLinkProps {
  userId: string;
  className?: string;
  children: React.ReactNode;
}

export default function CrewProfileLink({ userId, className, children }: CrewProfileLinkProps) {
  return (
    <Link
      to={`/admin/crew/${userId}`}
      className={className ?? 'hover:text-primary-600 hover:underline'}
    >
      {children}
    </Link>
  );
}
